module.exports = __webpack_public_path__ + "images/home/product/features-repository-eb7478d321336eb0b297aaaaf0c80b18.png";